// Generated by Melange

import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function KassaSubheader(Props) {
  let currentRoute = Props.currentRoute;
  let kkm = Props.kkm;
  let contextRoute = Props.contextRoute;
  let tmp;
  let exit = 0;
  let kkmId;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    tmp = "text-gray-medium";
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match = currentRoute._1;
        if (/* tag */ typeof match === "number" || typeof match === "string" || match.TAG !== /* Kassa */ 2) {
          tmp = "text-gray-medium";
        } else {
          const match$1 = match._0._0;
          if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string") {
            tmp = "text-gray-medium";
          } else {
            let tmp$1 = match$1._1;
            if (/* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" || tmp$1.TAG !== /* Receipts */ 1) {
              tmp = "text-gray-medium";
            } else {
              kkmId = match$1._0;
              exit = 1;
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$2 = currentRoute._0;
        if (/* tag */ typeof match$2 === "number" || typeof match$2 === "string" || match$2.TAG !== /* Orgs */ 1) {
          tmp = "text-gray-medium";
        } else {
          const match$3 = match$2._0;
          if (/* tag */ typeof match$3 === "number" || typeof match$3 === "string") {
            tmp = "text-gray-medium";
          } else {
            const match$4 = match$3._1;
            if (/* tag */ typeof match$4 === "number" || typeof match$4 === "string" || match$4.TAG !== /* Kassa */ 2) {
              tmp = "text-gray-medium";
            } else {
              const match$5 = match$4._0._0;
              if (/* tag */ typeof match$5 === "number" || typeof match$5 === "string") {
                tmp = "text-gray-medium";
              } else {
                let tmp$2 = match$5._1;
                if (/* tag */ typeof tmp$2 === "number" || typeof tmp$2 === "string" || tmp$2.TAG !== /* Receipts */ 1) {
                  tmp = "text-gray-medium";
                } else {
                  kkmId = match$5._0;
                  exit = 1;
                }
              }
            }
          }
        }
        break;
      default:
        tmp = "text-gray-medium";
    }
  }
  if (exit === 1) {
    tmp = kkmId === kkm.id ? "text-white" : "text-gray-medium";
  }
  let tmp$3;
  let exit$1 = 0;
  let kkmId$1;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    tmp$3 = "text-gray-medium";
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$6 = currentRoute._1;
        if (/* tag */ typeof match$6 === "number" || typeof match$6 === "string" || match$6.TAG !== /* Kassa */ 2) {
          tmp$3 = "text-gray-medium";
        } else {
          const match$7 = match$6._0._0;
          if (/* tag */ typeof match$7 === "number" || typeof match$7 === "string") {
            tmp$3 = "text-gray-medium";
          } else {
            let tmp$4 = match$7._1;
            if (/* tag */ typeof tmp$4 === "number" || typeof tmp$4 === "string" || tmp$4.TAG !== /* Journal */ 2) {
              tmp$3 = "text-gray-medium";
            } else {
              kkmId$1 = match$7._0;
              exit$1 = 1;
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$8 = currentRoute._0;
        if (/* tag */ typeof match$8 === "number" || typeof match$8 === "string" || match$8.TAG !== /* Orgs */ 1) {
          tmp$3 = "text-gray-medium";
        } else {
          const match$9 = match$8._0;
          if (/* tag */ typeof match$9 === "number" || typeof match$9 === "string") {
            tmp$3 = "text-gray-medium";
          } else {
            const match$10 = match$9._1;
            if (/* tag */ typeof match$10 === "number" || typeof match$10 === "string" || match$10.TAG !== /* Kassa */ 2) {
              tmp$3 = "text-gray-medium";
            } else {
              const match$11 = match$10._0._0;
              if (/* tag */ typeof match$11 === "number" || typeof match$11 === "string") {
                tmp$3 = "text-gray-medium";
              } else {
                let tmp$5 = match$11._1;
                if (/* tag */ typeof tmp$5 === "number" || typeof tmp$5 === "string" || tmp$5.TAG !== /* Journal */ 2) {
                  tmp$3 = "text-gray-medium";
                } else {
                  kkmId$1 = match$11._0;
                  exit$1 = 1;
                }
              }
            }
          }
        }
        break;
      default:
        tmp$3 = "text-gray-medium";
    }
  }
  if (exit$1 === 1) {
    tmp$3 = kkmId$1 === kkm.id ? "text-white" : "text-gray-medium";
  }
  let tmp$6;
  let exit$2 = 0;
  let kkmId$2;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string") {
    tmp$6 = "text-gray-medium";
  } else {
    switch (currentRoute.TAG) {
      case /* Org */ 6 :
        const match$12 = currentRoute._1;
        if (/* tag */ typeof match$12 === "number" || typeof match$12 === "string" || match$12.TAG !== /* Kassa */ 2) {
          tmp$6 = "text-gray-medium";
        } else {
          const match$13 = match$12._0._0;
          if (/* tag */ typeof match$13 === "number" || typeof match$13 === "string") {
            tmp$6 = "text-gray-medium";
          } else {
            let tmp$7 = match$13._1;
            if (/* tag */ typeof tmp$7 === "number" || typeof tmp$7 === "string" || tmp$7.TAG !== /* Settings */ 0) {
              tmp$6 = "text-gray-medium";
            } else {
              kkmId$2 = match$13._0;
              exit$2 = 1;
            }
          }
        }
        break;
      case /* Admin */ 7 :
        const match$14 = currentRoute._0;
        if (/* tag */ typeof match$14 === "number" || typeof match$14 === "string" || match$14.TAG !== /* Orgs */ 1) {
          tmp$6 = "text-gray-medium";
        } else {
          const match$15 = match$14._0;
          if (/* tag */ typeof match$15 === "number" || typeof match$15 === "string") {
            tmp$6 = "text-gray-medium";
          } else {
            const match$16 = match$15._1;
            if (/* tag */ typeof match$16 === "number" || typeof match$16 === "string" || match$16.TAG !== /* Kassa */ 2) {
              tmp$6 = "text-gray-medium";
            } else {
              const match$17 = match$16._0._0;
              if (/* tag */ typeof match$17 === "number" || typeof match$17 === "string") {
                tmp$6 = "text-gray-medium";
              } else {
                let tmp$8 = match$17._1;
                if (/* tag */ typeof tmp$8 === "number" || typeof tmp$8 === "string" || tmp$8.TAG !== /* Settings */ 0) {
                  tmp$6 = "text-gray-medium";
                } else {
                  kkmId$2 = match$17._0;
                  exit$2 = 1;
                }
              }
            }
          }
        }
        break;
      default:
        tmp$6 = "text-gray-medium";
    }
  }
  if (exit$2 === 1) {
    tmp$6 = kkmId$2 === kkm.id ? "text-white" : "text-gray-medium";
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: Curry._1(contextRoute, {
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: kkm.id,
              _1: /* View */ 3
            }
          }
        }),
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: Caml_obj.caml_equal(currentRoute, Curry._1(contextRoute, {
            TAG: /* Kassa */ 2,
            _0: {
              TAG: /* Kkms */ 0,
              _0: {
                TAG: /* Kkm */ 0,
                _0: kkm.id,
                _1: /* View */ 3
              }
            }
          })) ? "text-white" : "text-gray-medium",
          children: "Обзор"
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: Curry._1(contextRoute, {
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: kkm.id,
              _1: {
                TAG: /* Receipts */ 1,
                _0: /* List */ 0
              }
            }
          }
        }),
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: tmp,
          children: "Чеки"
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: Curry._1(contextRoute, {
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: kkm.id,
              _1: {
                TAG: /* Journal */ 2,
                _0: /* Logs */ 0
              }
            }
          }
        }),
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: tmp$3,
          children: "Журнал"
        })
      }),
      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
        route: Curry._1(contextRoute, {
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: kkm.id,
              _1: {
                TAG: /* Settings */ 0,
                _0: /* General */ 0
              }
            }
          }
        }),
        children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
          className: tmp$6,
          children: "Настройки"
        })
      })
    ],
    className: "flex justify-between bg-black px-4 py-3"
  });
}

const make = KassaSubheader;

export {
  make,
}
/* Buhta_cabinet__Link Not a pure module */
